/**
 * Core Authentication Hooks
 *
 * These hooks provide the fundamental authentication functionality
 * and are the foundation for all other auth hooks.
 */
import { useContext } from 'react';
import { AuthContext } from '../auth-context';
/**
 * Hook to use authentication context
 * This is the primary hook that provides access to all auth state and actions
 */
export function useAuthContext() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuthContext must be used within an AuthProvider');
    }
    return context;
}
/**
 * Hook to use authentication state and actions
 * Convenience hook that provides the same interface as before
 */
export function useAuth() {
    return useAuthContext();
}
/**
 * Hook to check if user is authenticated
 */
export function useIsAuthenticated() {
    const { isAuthenticated } = useAuthContext();
    return isAuthenticated;
}
/**
 * Hook to get authentication loading state
 */
export function useAuthLoading() {
    const { isLoading } = useAuthContext();
    return isLoading;
}
/**
 * Hook to get authentication error
 */
export function useAuthError() {
    const { error } = useAuthContext();
    return error;
}
